module.exports = __webpack_public_path__ + "static/media/door4_hover.cd3276a2.png";